import { render, staticRenderFns } from "./UploadDocumentCare.vue?vue&type=template&id=c7621b58&scoped=true"
import script from "./UploadDocumentCare.vue?vue&type=script&lang=ts"
export * from "./UploadDocumentCare.vue?vue&type=script&lang=ts"
import style0 from "./UploadDocumentCare.vue?vue&type=style&index=0&id=c7621b58&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7621b58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c7621b58')) {
      api.createRecord('c7621b58', component.options)
    } else {
      api.reload('c7621b58', component.options)
    }
    module.hot.accept("./UploadDocumentCare.vue?vue&type=template&id=c7621b58&scoped=true", function () {
      api.rerender('c7621b58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/documents/UploadDocumentCare.vue"
export default component.exports